import React from "react";
import attach from "mson-react/lib/attach";
import Typography from "@material-ui/core/Typography";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

class MDTextField extends React.PureComponent {
  render() {
    const { value } = this.props;

    return (
      <Typography component="div">
        <ReactMarkdown plugins={[gfm]} children={value} />
      </Typography>
    );
  }
}
const returnValue = attach(["value"])(MDTextField);

export default returnValue;
